export const OverflowMenuBulkProcessModule = angular
    .module('app.components.pageHeader.overflowMenuBulkProcess', [])
    .component('overflowMenuBulkProcess', {
        template: `
            <md-menu-item>
                <md-button ng-click="$ctrl.onClick()">
                    {{'ORDER.BULK_PROCESS_ORDERS' | translate}}
                </md-button>
            </md-menu-item>
        `,
        bindings: {
            onClick: '&'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/pageHeader/overflowMenu/overflowMenuBulkProcess.js